import { Component, input, model, output, signal } from '@angular/core';
import { DisplayMode } from '../session-sites-component';
import { EligibilitySession } from '../../../models/eligibility-session';
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { HelpFaqDialogComponent } from '../../util/help-faq-dialog-component/help-faq-dialog-component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { COMMERCIAL_ELIGIBILITY_ENABLED } from '../../../app';

@Component({
  selector: 'app-session-sites-header-component',
  imports: [MatButtonToggleModule, MatToolbarModule, MatTooltipModule, MatIconModule, MatMenuModule, FormsModule, MatButtonModule, RouterLink, CdkCopyToClipboard],
  templateUrl: './session-sites-header-component.html',
  styleUrl: './session-sites-header-component.css',
})
export class SessionSitesHeaderComponent {
  COMMERCIAL_ELIGIBILITY_ENABLED = COMMERCIAL_ELIGIBILITY_ENABLED;

  readonly openEligibilityModalClicked = output<void>();
  readonly openAccessConfigurationClicked = output<void>();

  readonly importSitesManuallyClicked = output<void>();
  readonly importSitesFromFileClicked = output<void>();
  readonly importSitesFromClientClicked = output<void>();

  readonly editSessionNameClicked = output<void>();
  readonly duplicateSessionClicked = output<void>();
  readonly shareSessionClicked = output<void>();

  readonly exportStdCsvClicked = output<void>();
  readonly exportStdXlsxClicked = output<void>();
  readonly exportNova2CsvClicked = output<void>();
  readonly exportNova2XlsxClicked = output<void>();

  readonly deleteSitesClicked = output<void>();
  readonly relaunchAddressValidation = output<void>();

  readonly session = input<EligibilitySession | null>(null);
  readonly selectedSitesLength = input<number>(0);
  readonly eligibilitySelectedSitesLength = input<number>(0);
  readonly toBeExportedSitesLength = input<number>(0);

  public displayMode = model<DisplayMode>('addressValidation');
  public readonly DISPLAY_MODE_OPTIONS = [
    {name: 'Fiabilisation', value: 'addressValidation'},
    {name: 'Éligibilité', value: 'eligibility'},
  ];

  readonly currentUrl = signal<string>('');

  constructor(
    private readonly dialog: MatDialog
  ) {
    this.currentUrl.set(window.location.href);
  }

  openHelp() {
    this.dialog.open(HelpFaqDialogComponent, {
      width: '80%',
      maxWidth: '95vw'
    });
  }
}
